export const renderConsoleArt = () => {
  console.info(`%c 🦊 ShapeShift DAO`, 'color: #3761F9; font-size: 16px; font-family: monospace')
  console.info(
    `%c 💬 Join our Discord https://discord.gg/shapeshift`,
    'color: #3761F9; font-size: 12px; font-family: monospace',
  )
  console.info(
    `%c 📝 See the DAO overview https://app.boardroom.info/shapeshift/overview`,
    'color: #3761F9; font-size: 12px; font-family: monospace',
  )
  console.info(
    `%c 🧑‍💻 Contribute on GitHub https://github.com/shapeshift`,
    'color: #3761F9; font-size: 12px; font-family: monospace',
  )
  console.info(
    `%c
    lcdOXWMMMMMMMMMMMMMMMMMMMMMMMMMMMMNKOdcd
    :  .';lx0NWMMMMMMMMMMMMMMMMMMNKOdc,'.  l
    o..dxl;'.':oxOOOOOOOOOOOOOkdc,..,:oko..k
    O..xWMWXOo. ..''''''''''''. .ckKNWMNo.,K
    X: cNMMMKl..o0XXXXXXXXXXXKx,.;kNMMMX; lN
    Wo ,KMNk,.:0WMMMMMMMMMMMMMMXd..c0WMO..kM
    MO..xKc..dNMMMMMMMMMMMMMMMMMW0c..dKo ,KM
    MX; .'.:0WMMMMMMMMMMMMMMMMMMMMNk,... lNM
    MWo   .:llllllllllllllllllllllll:.  .xWM
    MNl    .;::::::::::::::::::::::,.   .xWM
    MO..::..cONMMMMMMMMMMMMMMMMMWXx;.'l; ;KM
    X: :XW0l'.;kNMMMMMMMMMMMMMWKd'.,dXWO'.dW
    x..kWMMWKd,.,dKWMMMMMMMMW0l..:kNMMMNl ,K
    : .;ldk0XNXk;..l0WMMMMNk:..cONNK0xoc' .x
    Kd:.   ..,:ll:. .:k00x,..,coc;'.    'ckX
    MMWKxc.   .,,'..   ..   ..',,.  .'lkXWMM
    MMMMMWXkl'.'lkOko'    ;dOOxc'.,oONMMMMMM
    MMMMMMMMMXk:..cdc.    .ld:..cONMMMMMMMMM
    MMMMMMMMMMMW0l.          'oKWMMMMMMMMMMM
    MMMMMMMMMMMMMWKl.      .oXMMMMMMMMMMMMMM
    MMMMMMMMMMMMMMMW0c.  .lKWMMMMMMMMMMMMMMM
    MMMMMMMMMMMMMMMMMNo,;dNMMMMMMMMMMMMMMMMM
    `,
    'color: #3761F9; font-size: 12px; font-family: monospace',
  )
}
